import React from "react";
import { Grid, Progress, Segment } from "semantic-ui-react";
import { getPercentage, getProgressDisplayType } from "../../../../utils/utils";
import { ProgressDisplayStatus } from "./types";

type SimulationRunsProgressBarProps = {
  /** Long simulation runs total limit.*/
  longSimulationRunsLimit: number;
  /** Long simulation runs status or progress.*/
  longSimulationRunsValue: number;
  /** Short simulation runs total limit.*/
  shortSimulationRunsLimit: number;
  /** Short simulation runs value.*/
  shortSimulationRunsValue: number;
};

type SimulationRunsProgressBarState = {
  short: { progressDisplayTypeStatus: ProgressDisplayStatus; percentage: number };
  long: { progressDisplayTypeStatus: ProgressDisplayStatus; percentage: number };
};

class SimulationRunsProgressBar extends React.PureComponent<
  SimulationRunsProgressBarProps,
  SimulationRunsProgressBarState
> {
  constructor(props: SimulationRunsProgressBarProps) {
    super(props);
    const shortPercentage = getPercentage(
      props.shortSimulationRunsValue,
      props.shortSimulationRunsLimit
    );
    const longPercentage = getPercentage(
      props.longSimulationRunsValue,
      props.longSimulationRunsLimit
    );
    this.state = {
      short: {
        progressDisplayTypeStatus: getProgressDisplayType(shortPercentage),
        percentage: shortPercentage
      },
      long: {
        progressDisplayTypeStatus: getProgressDisplayType(longPercentage),
        percentage: longPercentage
      }
    };
  }

  render = () => (
    <Segment>
      <Progress
        progress="percent"
        percent={this.state.long.percentage}
        success={this.state.long.progressDisplayTypeStatus["success"]}
        warning={this.state.long.progressDisplayTypeStatus["warning"]}
        error={this.state.long.progressDisplayTypeStatus["error"]}
        style={{ margin: 0 }}
      />
      <Grid textAlign="center" style={{ height: "100%" }} verticalAlign="top">
        <Grid.Row columns={2}>
          <Grid.Column width={12} textAlign="left">
            <strong>Simulation runs with a duration of more than 10 years</strong>
          </Grid.Column>
          <Grid.Column width={4} textAlign="right">
            <span color="grey">
              {this.props.longSimulationRunsValue} of {this.props.longSimulationRunsLimit} runs
            </span>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Grid textAlign="center" style={{ height: "100%", marginTop: 0 }} verticalAlign="top">
        <Grid.Row columns={1} style={{ paddingBottom: 0 }}>
          <Grid.Column>
            <Progress
              progress="percent"
              percent={this.state.short.percentage}
              success={this.state.short.progressDisplayTypeStatus["success"]}
              warning={this.state.short.progressDisplayTypeStatus["warning"]}
              error={this.state.short.progressDisplayTypeStatus["error"]}
              style={{ marginBottom: 0 }}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={2} style={{ paddingTop: "1px", paddingBottom: "9px" }}>
          <Grid.Column width={12} textAlign="left">
            <strong>Simulation runs with a duration of less than (or equal to) 10 years</strong>
          </Grid.Column>
          <Grid.Column width={4} textAlign="right">
            <span color="grey">
              {this.props.shortSimulationRunsValue} of {this.props.shortSimulationRunsLimit} runs
            </span>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
}

export default SimulationRunsProgressBar;
